module.exports = __webpack_public_path__ + "img/cont-02-salute.9ff19b6b.svg";